import React, { useEffect, useState } from "react";
import ReportLayout from "../../../layouts/ReportMain";
import NuDateFormat from "../../../utils/NuDate";
import axiosInstance from "../../../services/axiosComman";
import { useFormik } from "formik";
import { useParams } from "react-router-dom";
import { useStandard } from "../../../context/StandardContext";
import { handleKeyDown } from "../../../utils/OtherFunctions";
import { CloseIcon, PaperClip } from "../../../assets/icons";
import DecryptData from "../../../utils/Decrypt";
import Swal from "sweetalert2";
import { NuInput } from "../../../utils/Inputs";
import FormikSelectTwo from "../../../utils/Select";

const Toast = Swal.mixin({
  toast: true,
  position: "bottom-end",
  showConfirmButton: false,
  timer: 4000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

function InternalAuditReport() {
  const { standardName } = useStandard();
  const { stdId } = useParams();
  const [data, setData] = useState([]);
  const [company, setCompany] = useState({
    name: "",
    location: "",
    companyLogo: "",
  });
  const [standardname, setStandardName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [status, setStatus] = useState([]);
  const [review, setReview] = useState("");
  const [relation, setRelation] = useState([]);
  const [hasData, setHasData] = useState(false);
  const [gettingData, setGettingData] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showMyModal, setShowMyModal] = useState(false);
  const [createNew, setCreateNew] = useState({
    standard: standardName || "",
    auditStartDate: "",
    auditEndDate: "",
    auditType: "",
    auditorName: "",
    companyName: "",
    location: "",
    department: "",
    documentClassification: "",
    status: "",
    attendees: "",
    auditConclusionsQstOne: "",
    auditConclusionsQstTwo: "",
    auditConclusionsQstThree: "",
    auditConclusionsQstFour: "",
    auditConclusionsQstFive: "",
    auditConclusionsQstSix: "",
    auditConclusionsQstSeven: "",
    auditConclusionsQstEight: "",
    auditConclusionsQstNine: "",
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (value, { resetForm }) => {
      setIsLoading(true);
      setGettingData(true);
      setTimeout(() => {
        setShowMyModal(false);
        setIsLoading(false);
      }, [5000]);
    },
  });

  function importData() {
    setIsDataLoading(true);
    let value = {
      standard_id: stdId,
      module_id: 2,
      type: 0,
      status_name: "",
      from_date: "",
      to_date: "",
    };
    axiosInstance
      .post(`/report/`, value)
      .then((res) => {
        // console.log(res.data);
        res?.data?.data && setData(res?.data?.data);
        setIsDataLoading(false);
        // setDataLength(res?.data?.data.length);
        res?.data?.status && setStatus(res?.data?.status);
        let dateValue = res.data.data || [];
        if (dateValue.length > 0) {
          setHasData(true);
          let fun = dateValue[0].final_status || null;
          if (fun == "review_and_approved") {
            setReview(true);
          } else {
            setReview("");
          }
        }
        if (dateValue.length == 0) {
          setIsDataLoading(false);
        }
        Toast.fire({
          icon: "success",
          title: "Data Imported Successfully",
        });
      })
      .catch((err) => {
        setIsDataLoading(false);
        console.log(err?.response?.data, "Error");
        Toast.fire({
          icon: "error",
          title: "Data Imported Unsuccessfully",
        });
      });
  }

  const Relation = async () => {
    await axiosInstance.get("/Master-Data/department_type").then((res) => {
      let data = res?.data?.data;
      let xyz = [];
      data.forEach((i) => {
        let x = { label: i?.value, value: i?.value };
        xyz.push(x);
      });
      res?.data && setRelation(xyz);
    });
  };

  useEffect(() => {
    getCompanyInfo();
    Relation();
    getStandard();
  }, [stdId]);

  useEffect(() => {
    setCreateNew({
      ...createNew,
      companyName: company?.name,
      location: company?.location,
    });
  }, [company]);

  async function getCompanyInfo() {
    await axiosInstance.get(`/company-info/`).then((res) => {
      let data = res?.data?.data[0];
      setCompany({
        name: data?.companyName || "",
        location: data?.city || "",
        companyLogo: data?.companyLogo || "",
      });
    });
  }

  function onClose() {
    setShowMyModal(false);
    setHasData(false);
  }

  const [pdfUrl, setPdfUrl] = useState(null);
  const userData = localStorage.getItem("aTaDrEsU")
    ? DecryptData("aTaDrEsU")
    : [];
  const UserName = userData?.user_name;
  const Location = userData?.location || "-";
  const Country = userData?.country || "-";
  const department = userData?.department || "-";

  useEffect(() => {
    const worker = new Worker(
      new URL("./InternalAuditReportList.jsx", import.meta.url)
    );

    worker.onmessage = function (e) {
      setPdfUrl(e.data);
      setIsDataLoading(false);
    };

    if (gettingData == true && data.length > 0) {
      worker.postMessage({
        data,
        status,
        company,
        standardname,
        review,
        startDate,
        endDate,
        Name: `Internal Audit Report`,
        UserName,
        Location,
        Country,
        department,
        userValue: formik.values,
      });
    }

    return () => worker.terminate();
  }, [gettingData, data]);

  function getStandard() {
    axiosInstance
      .get(`Standards/${stdId}`)
      .then((res) => {
        setStandardName(res?.data?.data.name);
        setStartDate(res?.data?.data.start_date);
        setEndDate(res?.data?.data.end_date);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  return (
    <>
      <ReportLayout>
        <div className="w-full h-[calc(100vh-170px)] overflow-hidden pb-4">
          <div className="mx-4 py-2 flex justify-between items-center">
            <p className=" text-sm 2xl:text-base font-[600]">
              Internal Audit Report
            </p>
            <div className=" flex gap-2 items-center">
              {pdfUrl && (
                <a
                  href={URL.createObjectURL(pdfUrl)}
                  download={`${standardname}-Internal Audit Report ${NuDateFormat(
                    {
                      value: new Date(),
                      format: "DD-MMM-YYYY",
                    }
                  )}.pdf`}
                >
                  <svg
                    fill="#7030a0"
                    viewBox="0 0 16 16"
                    height="22px"
                    width="22px"
                    //   {...props}
                  >
                    <path
                      fillRule="evenodd"
                      d="M14 4.5V14a2 2 0 01-2 2h-1v-1h1a1 1 0 001-1V4.5h-2A1.5 1.5 0 019.5 3V1H4a1 1 0 00-1 1v9H2V2a2 2 0 012-2h5.5L14 4.5zM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 00.161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 00-.46-.477c-.2-.12-.443-.179-.732-.179zm.545 1.333a.795.795 0 01-.085.38.574.574 0 01-.238.241.794.794 0 01-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 00.595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 00-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 01.354.454c.079.201.118.452.118.753a2.3 2.3 0 01-.068.592 1.14 1.14 0 01-.196.422.8.8 0 01-.334.252 1.298 1.298 0 01-.483.082h-.563v-2.707zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896z"
                    />
                  </svg>
                </a>
              )}

              <button
                className=" bg-primary px-3 py-1 text-white rounded-lg text-sm"
                onClick={() => setShowMyModal(true)}
              >
                Create Report
              </button>
            </div>
          </div>
          <div className=" w-full h-[calc(100vh-215px)] overflow-y-auto">
            <div className=" w-full grid grid-cols-3 px-4">
              <div>
                <TempComponent
                  label="Standard "
                  value={formik.values.standard || "-"}
                />
                <TempComponent
                  label="Audit Start Date "
                  value={
                    formik.values.auditStartDate != "" ? (
                      <NuDateFormat
                        value={formik.values.auditStartDate}
                        format="DD-MMM-YYYY"
                      />
                    ) : (
                      "-"
                    )
                  }
                />
                <TempComponent
                  label="Audit End Date "
                  value={
                    formik.values.auditEndDate != "" ? (
                      <NuDateFormat
                        value={formik.values.auditEndDate}
                        format="DD-MMM-YYYY"
                      />
                    ) : (
                      "-"
                    )
                  }
                />
                <TempComponent
                  label="Audit Type "
                  value={formik.values.auditType || "-"}
                />
                <TempComponent
                  label="Auditor Name "
                  value={formik.values.auditorName || "-"}
                />
              </div>
              <div>
                <TempComponent
                  label="Company Name"
                  value={formik.values.companyName || "-"}
                />
                <TempComponent
                  label="Location"
                  value={formik.values.location || "-"}
                />
                <TempComponent
                  label="Department"
                  value={formik.values.department || "-"}
                />
                <TempComponent
                  label="Document Classification"
                  value={formik.values.documentClassification || "-"}
                />
                <TempComponent
                  label="Status"
                  value={formik.values.status || "-"}
                />
              </div>
              <div>
                <TempComponent
                  label="Attendees"
                  value={formik.values.attendees || "-"}
                />
              </div>
            </div>
            <div className=" w-full py-3 bg-tabletitle mb-3 mt-4">
              <p className=" text-xs 2xl:text-sm px-4 font-[600]">
                Audit criteria
              </p>
            </div>
            <p className=" text-[11px] 2xl:text-[13px] px-6 ">
              The audit criteria (the set of requirements) for this audit are
              all normative clauses of standard
            </p>
            <div className=" w-full px-12 text-[11px] 2xl:text-[13px]">
              <ul className="list-disc">
                <li className="py-1">
                  Clause 4 – Context of the organization{" "}
                </li>
                <li className="py-1">Clause 5 – Leadership</li>
                <li className="py-1">Clause 6 – Planning</li>
                <li className="py-1">Clause 7 – Support</li>
                <li className="py-1">Clause 8 – Operation</li>
                <li className="py-1">Clause 9 – Performance evaluation</li>
                <li className="py-1">Clause 10 – Improvement </li>
                <li className="py-1">
                  Annex A – Information security controls reference{" "}
                </li>
                <li className="py-1">Use of logo and trademark </li>
                <li className="py-1">
                  Documentation and processes defined in the management system
                  developed by the client.{" "}
                </li>
              </ul>
            </div>
            <div className=" w-full py-3 bg-tabletitle mb-3 mt-4">
              <p className=" text-xs 2xl:text-sm px-4 font-[600]">
                Significant audit trails followed.
              </p>
            </div>
            <p className=" text-[11px] 2xl:text-[13px] px-6 ">
              Notes on usage by the auditor:
            </p>
            <p className=" text-[11px] 2xl:text-[13px] px-6 py-2 ">
              Under the column “Status”, please use the following key to record
              your assessment result for each clause:
            </p>
            <div className=" w-full px-12 text-[11px] 2xl:text-[13px]">
              <ul className="list-disc">
                <li className="py-1">A = Acceptable, </li>
                <li className="py-1">N/A = Not Applicable (Out of Scope),</li>
                <li className="py-1">MaNC = Major Nonconformity</li>
                <li className="py-1">MiNC = Minor Nonconformity</li>
                <li className="py-1">OBS = Observation</li>
                <li className="py-1">OFI = Opportunity for improvement</li>
              </ul>
            </div>
            <div className=" w-full my-2">
              <table className="w-full">
                <thead className=" bg-tabletitle">
                  <tr className="text-xs 2xl:text-sm font-medium">
                    {header.map((header, i) => (
                      <th
                        className={`py-3 ${header.width} ${header.align} px-4`}
                        key={i}
                      >
                        {header.headone}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr className="odd:bg-tableodd even:bg-tableeven  my-1 text-[11px] 2xl:text-[13px] py-2 font-medium">
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-left w-[80%]">
                      Has there been any serious deviation from the audit plan?
                      (If yes, please specify)
                    </td>
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-center w-[10%]">
                      {formik.values.auditConclusionsQstOne == "yes" && "Yes"}
                    </td>
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-center w-[10%]">
                      {formik.values.auditConclusionsQstOne == "no" && "No"}
                    </td>
                  </tr>
                  <tr className="odd:bg-tableodd even:bg-tableeven  my-1 text-[11px] 2xl:text-[13px] py-2 font-medium">
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-left w-[80%]">
                      Are there any significant issues impacting the audit
                      program? (If yes, please specify)
                    </td>
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-center w-[10%]">
                      {formik.values.auditConclusionsQstTwo == "yes" && "Yes"}
                    </td>
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-center w-[10%]">
                      {formik.values.auditConclusionsQstTwo == "no" && "No"}
                    </td>
                  </tr>
                  <tr className="odd:bg-tableodd even:bg-tableeven  my-1 text-[11px] 2xl:text-[13px] py-2 font-medium">
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-left w-[80%]">
                      Are there any significant changes affecting the management
                      system since last audit took place? (If yes, please list
                      the significant changes)
                    </td>
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-center w-[10%]">
                      {formik.values.auditConclusionsQstThree == "yes" && "Yes"}
                    </td>
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-center w-[10%]">
                      {formik.values.auditConclusionsQstThree == "no" && "No"}
                    </td>
                  </tr>
                  <tr className="odd:bg-tableodd even:bg-tableeven  my-1 text-[11px] 2xl:text-[13px] py-2 font-medium">
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-left w-[80%]">
                      Are there any unresolved issues affecting the management
                      system since last audit took place? (If yes, please list
                      the unresolved issues)
                    </td>
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-center w-[10%]">
                      {formik.values.auditConclusionsQstFour == "yes" && "Yes"}
                    </td>
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-center w-[10%]">
                      {formik.values.auditConclusionsQstFour == "no" && "No"}
                    </td>
                  </tr>
                  <tr className="odd:bg-tableodd even:bg-tableeven  my-1 text-[11px] 2xl:text-[13px] py-2 font-medium">
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-left w-[80%]">
                      The verification of the effectiveness of the corrective
                      action taken regarding previously identified
                      nonconformities has been performed and is satisfactory
                      (please list any comments if needed)
                    </td>
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-center w-[10%]">
                      {formik.values.auditConclusionsQstFive == "yes" && "Yes"}
                    </td>
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-center w-[10%]">
                      {formik.values.auditConclusionsQstFive == "no" && "No"}
                    </td>
                  </tr>
                  <tr className="odd:bg-tableodd even:bg-tableeven  my-1 text-[11px] 2xl:text-[13px] py-2 font-medium">
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-left w-[80%]">
                      The management system is designed to achieve the
                      organization’s policy objectives
                    </td>
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-center w-[10%]">
                      {formik.values.auditConclusionsQstSix == "yes" && "Yes"}
                    </td>
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-center w-[10%]">
                      {formik.values.auditConclusionsQstSix == "no" && "No"}
                    </td>
                  </tr>
                  <tr className="odd:bg-tableodd even:bg-tableeven  my-1 text-[11px] 2xl:text-[13px] py-2 font-medium">
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-left w-[80%]">
                      The management system is designed to meet statutory,
                      regulatory and contractual requirements
                    </td>
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-center w-[10%]">
                      {formik.values.auditConclusionsQstSeven == "yes" && "Yes"}
                    </td>
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-center w-[10%]">
                      {formik.values.auditConclusionsQstSeven == "no" && "No"}
                    </td>
                  </tr>
                  <tr className="odd:bg-tableodd even:bg-tableeven  my-1 text-[11px] 2xl:text-[13px] py-2 font-medium">
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-left w-[80%]">
                      The internal audit and management review processes are in
                      place and adequate
                    </td>
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-center w-[10%]">
                      {formik.values.auditConclusionsQstEight == "yes" && "Yes"}
                    </td>
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-center w-[10%]">
                      {formik.values.auditConclusionsQstEight == "no" && "No"}
                    </td>
                  </tr>
                  <tr className="odd:bg-tableodd even:bg-tableeven  my-1 text-[11px] 2xl:text-[13px] py-2 font-medium">
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-left w-[80%]">
                      The audit was successful in meeting the stated objectives
                    </td>
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-center w-[10%]">
                      {formik.values.auditConclusionsQstNine == "yes" && "Yes"}
                    </td>
                    <td className="px-4 py-3 text-gray-900 whitespace-normal text-center w-[10%]">
                      {formik.values.auditConclusionsQstNine == "no" && "No"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className=" w-full my-2">
              <table className="w-full">
                <thead className=" bg-tabletitle">
                  <tr className="text-xs 2xl:text-sm font-medium">
                    {reportHeader.map((header, i) => (
                      <th
                        className={`py-3 ${header.width} ${header.align}`}
                        key={i}
                      >
                        {header.headone}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    <>
                      {data?.map((i, idx) => {
                        return (
                          <tr
                            className="odd:bg-tableodd even:bg-tableeven  my-1 text-xs 2xl:text-sm py-2"
                            key={idx}
                          >
                            <td className="px-2 py-3 xl:px-8 text-gray-900 whitespace-normal w-[5%]">
                              {i?.serial_number || ""}
                            </td>

                            {/* <td className="px-2 xl:px-8 text-gray-900 whitespace-normal w-[16%]">
                            {i?.section || ""}
                          </td> */}
                            <td className="pr-2 text-gray-900  whitespace-normal text-center w-[8%]">
                              {i.sub_section_no || ""}
                            </td>
                            <td className="text-gray-900 whitespace-normal w-[30%]">
                              {i.question_activity || ""}
                            </td>
                            <td className="text-gray-900 whitespace-normal capitalize text-center w-[7%]">
                              {i.status_name || ""}
                            </td>
                            <td className="text-gray-900 whitespace-normal text-center w-[9%]">
                              {i.completion_date &&
                                i.completion_date != "" &&
                                i.completion_date != "None" && (
                                  <NuDateFormat
                                    value={i.completion_date}
                                    format="DD-MMM-YYYY"
                                  />
                                )}
                            </td>
                            <td className="text-gray-900 whitespace-normal text-center w-[9%]">
                              {i.reminder_date &&
                                i.reminder_date != "" &&
                                i.reminder_date != "None" && (
                                  <NuDateFormat
                                    value={i.reminder_date}
                                    format="DD-MMM-YYYY"
                                  />
                                )}
                            </td>
                            <td className="text-gray-900 whitespace-normal capitalize text-center w-[9%]">
                              {i.confirmative_status || ""}
                            </td>
                            <td className="text-gray-900 whitespace-normal capitalize text-center w-[9%]">
                              {i.status_definition || ""}
                            </td>
                            <td className="text-gray-900 whitespace-normal capitalize text-center w-[8%]">
                              {(i?.attachment && <PaperClip />) || ""}
                            </td>
                          </tr>
                        );
                      })}
                    </>
                  ) : (
                    <tr className=" w-full relative">
                      <td colspan="9" className=" w-full h-48">
                        <div className=" w-full h-full flex justify-center items-center">
                          <p className=" text-base font-semibold">No Data</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </ReportLayout>

      {showMyModal && (
        <div
          id="modal"
          // onClick={onClose}
          className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
          flex justify-center items-center "
        >
          <div className="bg-white mt-12 p-2 rounded-xl w-9/12">
            <div className="flex items-start justify-between px-5 py-2  rounded-t">
              <h3 className="text-base 2xl:text-lg font-semibold">
                Create Report
              </h3>
              <span
                className="h-6 w-6 text-2xl block cursor-pointer"
                onClick={onClose}
              >
                <CloseIcon />
              </span>
            </div>
            <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
              <div className="overflow-y-auto max-h-[calc(100vh-180px)] ">
                <div className="relative px-6 pb-6 flex flex-wrap justify-between">
                  <NuInput
                    formik={formik}
                    name="standard"
                    label="Standard"
                    width="w-full lg:w-8/12"
                    type="text"
                    placeholder="Standard Name"
                    disabled={true}
                  />
                  <NuInput
                    formik={formik}
                    name="auditType"
                    label="Audit Type"
                    width="w-full lg:w-4/12"
                    type="text"
                    placeholder="Audit Type"
                  />

                  <NuInput
                    formik={formik}
                    name="auditStartDate"
                    label="Audit Start Date"
                    width="w-full lg:w-4/12"
                    type="date"
                    placeholder="Audit Start Date"
                  />

                  <NuInput
                    formik={formik}
                    name="auditEndDate"
                    label="Audit End Date"
                    width="w-full lg:w-4/12"
                    type="date"
                    placeholder="Audit End Date"
                  />
                  <NuInput
                    formik={formik}
                    name="auditorName"
                    label="Auditor Name"
                    width="w-full lg:w-4/12"
                    type="text"
                    placeholder="Auditor Name"
                  />

                  <NuInput
                    formik={formik}
                    name="companyName"
                    label="Company"
                    width="w-full lg:w-8/12"
                    type="text"
                    placeholder="Company"
                    disabled={true}
                  />
                  <NuInput
                    formik={formik}
                    name="location"
                    label="Location"
                    width="w-full lg:w-4/12"
                    type="text"
                    placeholder="Location"
                    disabled={true}
                  />
                  <FormikSelectTwo
                    formik={formik}
                    name="department"
                    label="Department"
                    width="w-4/12"
                    placeholder="Select Department"
                    Options={relation}
                    zindex={12}
                  />
                  <NuInput
                    formik={formik}
                    name="documentClassification"
                    label="Document Classification"
                    width="w-full lg:w-4/12"
                    type="text"
                    placeholder="Document Classification"
                  />

                  <FormikSelectTwo
                    formik={formik}
                    name="status"
                    label="Status"
                    width="w-4/12"
                    placeholder="Select Status"
                    Options={
                      [
                        { value: "completed", label: "Completed" },
                        { value: "in progress", label: "In Progress" },
                        { value: "yet to start", label: "Yet to Start" },
                      ]
                    }
                    zindex={12}
                  />
                  <NuInput
                    formik={formik}
                    name="attendees"
                    label="Attendees"
                    width="w-full lg:w-4/12"
                    type="text"
                    placeholder="Attendees"
                  />
                  {/* <MainForm formInputs={formInputs} formik={formik} /> */}
                  <div className=" w-full lg:w-8/12">
                    <button
                      onClick={() => importData()}
                      disabled={isDataLoading}
                      className={` ${
                        isDataLoading == true
                          ? " cursor-not-allowed bg-gray-400"
                          : " cursor-pointer bg-primary"
                      } mt-10 mx-6  text-white px-4 py-2 rounded-lg text-xs 2xl:text-sm`}
                      onKeyDown={handleKeyDown}
                    >
                      Import Data
                    </button>
                  </div>
                </div>
                {hasData == true && (
                  <div className=" w-full px-4">
                    <table className=" w-full border-collapse border-none">
                      <tbody>
                        <tr className=" py-2 w-full">
                          <td className="px-6 w-[85%] font-semibold">
                            Audit conclusions
                          </td>
                          <td className=" w-[7.5%] text-center font-semibold">
                            Yes
                          </td>
                          <td className=" w-[7.5%] text-center font-semibold">
                            No
                          </td>
                        </tr>
                        <tr className=" py-2 w-full">
                          <td className="px-6 w-[85%] py-2  text-sm">
                            Has there been any serious deviation from the audit
                            plan? (If yes, please specify)
                          </td>
                          <td className=" w-[7.5%] py-2 text-center text-sm">
                            <input
                              type="radio"
                              name="auditConclusionsQstOne"
                              value="yes"
                              checked={
                                formik.values.auditConclusionsQstOne === "yes"
                              }
                              onChange={formik.handleChange}
                              className=" cursor-pointer"
                            />
                          </td>
                          <td className=" w-[7.5%] py-2 text-center text-sm">
                            <input
                              type="radio"
                              name="auditConclusionsQstOne"
                              value="no"
                              checked={
                                formik.values.auditConclusionsQstOne === "no"
                              }
                              onChange={formik.handleChange}
                              className=" cursor-pointer"
                            />
                          </td>
                        </tr>
                        <tr className=" py-2 w-full">
                          <td className="px-6 w-[85%] py-2  text-sm">
                            Are there any significant issues impacting the audit
                            program? (If yes, please specify)
                          </td>
                          <td className=" w-[7.5%] py-2 text-center text-sm">
                            <input
                              type="radio"
                              name="auditConclusionsQstTwo"
                              value="yes"
                              checked={
                                formik.values.auditConclusionsQstTwo === "yes"
                              }
                              onChange={formik.handleChange}
                              className=" cursor-pointer"
                            />
                          </td>
                          <td className=" w-[7.5%] py-2 text-center text-sm">
                            <input
                              type="radio"
                              name="auditConclusionsQstTwo"
                              value="no"
                              checked={
                                formik.values.auditConclusionsQstTwo === "no"
                              }
                              onChange={formik.handleChange}
                              className=" cursor-pointer"
                            />
                          </td>
                        </tr>
                        <tr className=" py-2 w-full">
                          <td className="px-6 w-[85%] py-2  text-sm">
                            Are there any significant changes affecting the
                            management system since last audit took place? (If
                            yes, please list the significant changes)
                          </td>
                          <td className=" w-[7.5%] py-2 text-center text-sm">
                            <input
                              type="radio"
                              name="auditConclusionsQstThree"
                              value="yes"
                              checked={
                                formik.values.auditConclusionsQstThree === "yes"
                              }
                              onChange={formik.handleChange}
                              className=" cursor-pointer"
                            />
                          </td>
                          <td className=" w-[7.5%] py-2 text-center text-sm">
                            <input
                              type="radio"
                              name="auditConclusionsQstThree"
                              value="no"
                              checked={
                                formik.values.auditConclusionsQstThree === "no"
                              }
                              onChange={formik.handleChange}
                              className=" cursor-pointer"
                            />
                          </td>
                        </tr>
                        <tr className=" py-2 w-full">
                          <td className="px-6 w-[85%] py-2  text-sm">
                            Are there any unresolved issues affecting the
                            management system since last audit took place? (If
                            yes, please list the unresolved issues)
                          </td>
                          <td className=" w-[7.5%] py-2 text-center text-sm">
                            <input
                              type="radio"
                              name="auditConclusionsQstFour"
                              value="yes"
                              checked={
                                formik.values.auditConclusionsQstFour === "yes"
                              }
                              onChange={formik.handleChange}
                              className=" cursor-pointer"
                            />
                          </td>
                          <td className=" w-[7.5%] py-2 text-center text-sm">
                            <input
                              type="radio"
                              name="auditConclusionsQstFour"
                              value="no"
                              checked={
                                formik.values.auditConclusionsQstFour === "no"
                              }
                              onChange={formik.handleChange}
                              className=" cursor-pointer"
                            />
                          </td>
                        </tr>
                        <tr className=" py-2 w-full">
                          <td className="px-6 w-[85%] py-2  text-sm">
                            The verification of the effectiveness of the
                            corrective action taken regarding previously
                            identified nonconformities has been performed and is
                            satisfactory (please list any comments if needed)
                          </td>
                          <td className=" w-[7.5%] py-2 text-center text-sm">
                            <input
                              type="radio"
                              name="auditConclusionsQstFive"
                              value="yes"
                              checked={
                                formik.values.auditConclusionsQstFive === "yes"
                              }
                              onChange={formik.handleChange}
                              className=" cursor-pointer"
                            />
                          </td>
                          <td className=" w-[7.5%] py-2 text-center text-sm">
                            <input
                              type="radio"
                              name="auditConclusionsQstFive"
                              value="no"
                              checked={
                                formik.values.auditConclusionsQstFive === "no"
                              }
                              onChange={formik.handleChange}
                              className=" cursor-pointer"
                            />
                          </td>
                        </tr>
                        <tr className=" py-2 w-full">
                          <td className="px-6 w-[85%] py-2  text-sm">
                            The management system is designed to achieve the
                            organization’s policy objectives
                          </td>
                          <td className=" w-[7.5%] py-2 text-center text-sm">
                            <input
                              type="radio"
                              name="auditConclusionsQstSix"
                              value="yes"
                              checked={
                                formik.values.auditConclusionsQstSix === "yes"
                              }
                              onChange={formik.handleChange}
                              className=" cursor-pointer"
                            />
                          </td>
                          <td className=" w-[7.5%] py-2 text-center text-sm">
                            <input
                              type="radio"
                              name="auditConclusionsQstSix"
                              value="no"
                              checked={
                                formik.values.auditConclusionsQstSix === "no"
                              }
                              onChange={formik.handleChange}
                              className=" cursor-pointer"
                            />
                          </td>
                        </tr>
                        <tr className=" py-2 w-full">
                          <td className="px-6 w-[85%] py-2  text-sm">
                            The management system is designed to meet statutory,
                            regulatory and contractual requirements
                          </td>
                          <td className=" w-[7.5%] py-2 text-center text-sm">
                            <input
                              type="radio"
                              name="auditConclusionsQstSeven"
                              value="yes"
                              checked={
                                formik.values.auditConclusionsQstSeven === "yes"
                              }
                              onChange={formik.handleChange}
                              className=" cursor-pointer"
                            />
                          </td>
                          <td className=" w-[7.5%] py-2 text-center text-sm">
                            <input
                              type="radio"
                              name="auditConclusionsQstSeven"
                              value="no"
                              checked={
                                formik.values.auditConclusionsQstSeven === "no"
                              }
                              onChange={formik.handleChange}
                              className=" cursor-pointer"
                            />
                          </td>
                        </tr>
                        <tr className=" py-2 w-full">
                          <td className="px-6 w-[85%] py-2  text-sm">
                            The internal audit and management review processes
                            are in place and adequate
                          </td>
                          <td className=" w-[7.5%] py-2 text-center text-sm">
                            <input
                              type="radio"
                              name="auditConclusionsQstEight"
                              value="yes"
                              checked={
                                formik.values.auditConclusionsQstEight === "yes"
                              }
                              onChange={formik.handleChange}
                              className=" cursor-pointer"
                            />
                          </td>
                          <td className=" w-[7.5%] py-2 text-center text-sm">
                            <input
                              type="radio"
                              name="auditConclusionsQstEight"
                              value="no"
                              checked={
                                formik.values.auditConclusionsQstEight === "no"
                              }
                              onChange={formik.handleChange}
                              className=" cursor-pointer"
                            />
                          </td>
                        </tr>
                        <tr className=" py-2 w-full">
                          <td className="px-6 py-2 w-[85%]  text-sm">
                            The audit was successful in meeting the stated
                            objectives
                          </td>
                          <td className=" w-[7.5%] py-2 text-center text-sm">
                            <input
                              type="radio"
                              name="auditConclusionsQstNine"
                              value="yes"
                              checked={
                                formik.values.auditConclusionsQstNine === "yes"
                              }
                              onChange={formik.handleChange}
                              className=" cursor-pointer"
                            />
                          </td>
                          <td className=" w-[7.5%] py-2 text-center text-sm">
                            <input
                              type="radio"
                              name="auditConclusionsQstNine"
                              value="no"
                              checked={
                                formik.values.auditConclusionsQstNine === "no"
                              }
                              onChange={formik.handleChange}
                              className=" cursor-pointer"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
                <div className="flex items-center justify-end px-6 py-6 rounded-b">
                  <button
                    onClick={onClose}
                    className={` ${
                      isLoading == true
                        ? " bg-slate-300 cursor-wait"
                        : " bg-text "
                    } hover:shadow-menu text-white px-6 py-2 mr-2 rounded-xl`}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className={` ${
                      isLoading == true
                        ? " bg-red-300 cursor-wait"
                        : " bg-primary "
                    } hover:shadow-button text-white px-6 py-2 mr-2 rounded-xl`}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default InternalAuditReport;

function TempComponent({ label = "", value = "" }) {
  return (
    <div className=" w-full px-2 py-1 text-[11px] 2xl:text-[13px] flex items-center gap-1">
      <div className=" w-[40%] font-semibold">{label}</div>
      <div className=" w-[1%]">:</div>
      <div className=" w-[58%]">{value}</div>
    </div>
  );
}

const header = [
  {
    headone: "Audit conclusions",
    width: "w-[80%]",
    align: "text-left",
  },
  {
    headone: "Yes",
    width: "w-[10%]",
    align: "text-center",
  },
  {
    headone: "No",
    width: "w-[10%]",
    align: "text-center",
  },
];

const reportHeader = [
  {
    headone: "Sl.No",
    width: "w-[5%]",
    padding: "",
    align: "text-center",
  },
  {
    headone: "Sub-Section",
    width: "w-[8%]",
    padding: "",
    align: "text-center",
  },
  {
    headone: "Questions / Activity",
    width: "w-[30%]",
    padding: "",
    align: "text-center",
  },
  {
    headone: "Status",
    width: "w-[7%]",
    padding: "",
    align: "text-center",
  },
  {
    headone: "Completed Date",
    width: "w-[9%]",
    padding: "",
    align: "text-center",
  },
  {
    headone: "Reminder Date",
    width: "w-[9%]",
    padding: "",
    align: "text-center",
  },
  {
    headone: "Conformity Status",
    width: "w-[9%]",
    padding: "",
    align: "text-center",
  },
  {
    headone: "Definition",
    width: "w-[9%]",
    padding: "",
    align: "text-center",
  },
  {
    headone: "Artefact",
    width: "w-[8%]",
    padding: "",
    align: "text-center",
  },
];
